import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Button.module.css';
export const Button = forwardRef(({ variant = 'primary', size = 'medium', fullWidth = false, loading = false, glass = false, disabled, className = '', children, ...props }, ref) => {
    const classes = [
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        loading && styles.loading,
        disabled && styles.disabled,
        glass && styles.glass,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("button", { ref: ref, className: classes, disabled: disabled || loading, ...props, children: [loading && _jsx("span", { className: styles.spinner, "aria-hidden": "true" }), _jsx("span", { className: styles.content, children: children })] }));
});
Button.displayName = 'Button';
